import Vue from 'vue'
import Vuex from 'vuex'
import http from 'axios'

import typeDefs from '../infobit-typedefs'
import sortModes from '../infobit-sortmodes'

import treePanel from './modules/tree-panel'
import inbox from './modules/inbox'
import detailPanel from './modules/detail-panel'
import PasteAction from '../paste-action'

Vue.use(Vuex)

const DEFAULT_USER = 'nosconte.infobits'

const store = new Vuex.Store({

  state: {
    typeDefs,                 // infobit type definitions
    sortModes,                // infobit child sort modes
    user: undefined,          // name of the logged in user (string); empty string if no user is logged in
    infobitId: undefined,     // ID of the selected infobit, or undefined if no infobit is selected.
                              // Must be consistent with detail panel "infobit" state.
    users: undefined,         // all users in the infobits system (array of string)
    modKeys: {},              // state of modifier keys ("shiftKey" and "altKey" booleans)
    clipboard: {
      content: undefined,     // the clipboard content: either an infobit (object) in case of action=INSERT,
                              // or a node (object) in case of action MOVE, COPY, TRANSCLUDE.
                              // Undefined if clipboard is empty.
      action: undefined       // action to be performed on paste (PasteAction).
                              // If clipboard is empty, action has no meaning (must not be evaluated)
    }
  },

  getters: {
    //
    isClipboardEmpty: state => !state.clipboard.content,

    // ID of the node in the clipboard or undefined if there is no node in the clipboard
    clipboardNode: (state, getters) => {
      if (!getters.isClipboardEmpty && state.clipboard.action !== PasteAction.INSERT) {
        return state.clipboard.content
      }
    },

    // An array of node IDs.
    // In case a node is contained in the clipboard the array contains its ID and the IDs of all its child nodes.
    // If no node is contained in the clipboard the array is empty.
    childNodeIds: (state, getters) => {
      var node = getters.clipboardNode
      return node && buildChildNodeIds(node) || []
    }
  },

  actions: {

    /**
     * @param   user    the user (name) whose tree is initially shown.
     *                  If empty string the default user's tree is shown. If no default user is configured or
     *                  no such user account exists the first user's (as in "users" list) tree is shown.
     */
    initStore ({state, dispatch}, user) {
      console.log('initStore', user)
      state.user = user
      http.get('/infobits/tree').then(response => {
        state.users = response.data.map(tree => tree.uri.substr('infobits.tree.'.length))
        dispatch('setSelectedUser', user || state.users.includes(DEFAULT_USER) && DEFAULT_USER || state.users[0])
      })
      inbox.state.loading = true
      http.get('/infobits/inbox').then(response => {
        inbox.state.infobits = response.data.infobits
        inbox.state.loading = false
      })
    },

    logout ({state}) {
      state.user = ''
    },

    setModKeys ({state}, modKeys) {
      state.modKeys = modKeys
    },

    copyToClipboard ({state}, {content, action}) {
      console.log('on copyToClipboard', content, action)
      state.clipboard.content = content
      state.clipboard.action = action
    }
  },

  modules: {
    treePanel,
    inbox,
    detailPanel
  }
})

export default store

// Builds an array which contains the id of the passed node and the ids of all its child nodes
function buildChildNodeIds (node) {
  var childNodeIds = []
  pushNodeIds(node)
  return childNodeIds

  // Pushes the passed node (its ID) and their childs (recursively)
  function pushNodeIds (node) {
    childNodeIds.push(node.id)
    node.nodes.forEach(child => {
      pushNodeIds(child)
    })
  }
}

store.watch(
  state => state.treePanel.selectedUser,
  _ => store.dispatch('loadTree')
)

store.watch(
  state => state.infobitId,
  infobitId => {
    if (infobitId) {
      store.dispatch('onSelectInfobit', infobitId)
    }
  }
)



// WEBPACK FOOTER //
// ./src/store/index.js